
import Home from './Home'
import Lesson from './Lesson'
import Student from './Student'
import Definition from './Definition'
import library from './library'
// import BoardingHouse from './BoardingHouse'
import LearningCalendar from './LearningCalendar'
// import Service from './Service'
import Complaint from './Complaint'
import Request from './Request'
// import Order from './Order'
// import Survey from './Survey'
import OnlineLesson from './OnlineLesson'
import Choose from './Choose'

export default [
  ...Home,
  ...LearningCalendar,
  ...Student,
  ...Lesson,
  ...Choose,
  ...OnlineLesson,
  ...Definition,
  ...library,
  // ...BoardingHouse,
  // ...Order,
  // ...Service,
  ...Complaint,
  ...Request,
  // ...OnlineLesson,
  // ...Survey,
]
